import React, { FC, useState } from 'react';
import AuthEntryLayout from 'layouts/AuthEntryLayout/AuthEntryLayout';

import { IUser, ConfirmBirthdateData } from 'types';
import { useAppDispatch } from 'store';
import { confirmBirthdateAction } from 'store/auth/auth.reducer';
import { ProfileAgreement } from './components/ProfileAgreement/ProfileAgreement';
import { BirthdateForm } from './components/BirthdateForm/BirthdateForm';

interface Props {
  onNext: () => void;
  onCancel: () => void;
  profile: IUser,
  accessToken: string,
}

export const ProfileVerification: FC<Props> = ({ accessToken, profile, onNext, onCancel }) => {
  const dispatch = useAppDispatch();
  const [agreed, setAgreed] = useState<boolean>(false);

  const handleOk = () => setAgreed(true);
  const handleConfirmBirthdate = async ({ birthdate }: Pick<ConfirmBirthdateData, 'birthdate'>) => {
    await dispatch(confirmBirthdateAction({ birthdate, accessToken }));
    onNext();
  };

  return (
    <AuthEntryLayout title="Восстановление пароля">
      {!agreed
        ? <ProfileAgreement profile={profile} onCancel={onCancel} onOk={handleOk} />
        : <BirthdateForm onSubmit={handleConfirmBirthdate} onCancel={onCancel} />}
    </AuthEntryLayout>
  );
};
